import { dropdownTriggerClassname } from "app/components/Dropdown";
import { EpicIcon, TicketsIcon } from "app/components/Icons";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { getTicketTypeByIds } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/helper";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import StatusSelectionButton from "./StatusSelectionButton";

interface TicketTypeDropdownProps {
  value: string;
  setValue: (value: string) => void;
  ticketTypes: ITicketTypes[];
  isAddEpicModal?: boolean;
  epicColor?: string;
}

const TicketTypeDropdown: React.FC<TicketTypeDropdownProps> = ({
  setValue,
  value,
  ticketTypes,
  isAddEpicModal = false,
  epicColor,
}) => {
  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, value)[0];
  }, [ticketTypes, value]);
  const updateValue = (data: ITicketTypes) => {
    setValue(data._id);
  };

  return (
    <CommonTicketTypeSelection
      trigger={
        <button
          className={clsx(
            "flex items-center justify-between w-full px-2 py-2 rounded-md ",
            dropdownTriggerClassname,
          )}
        >
          <StatusSelectionButton
            label="Ticket type:"
            icon={<TicketsIcon size={18} color="#79808A" />}
            className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
            selectedIcon={
              ticketType &&
              (isAddEpicModal && epicColor ? (
                <EpicIcon size={18} color={epicColor} />
              ) : (
                <TicketTypeIcon iconName={ticketType?.icon} />
              ))
            }
            selectedLabel={ticketType?.name}
            {...(isAddEpicModal && epicColor ? { textColor: epicColor } : {})}
          />
        </button>
      }
      align="end"
      dropDownClassName="min-w-[210px]"
      value={value}
      showEndIcon
      setValue={updateValue}
    />
  );
};

export default TicketTypeDropdown;
